import * as types from './shipping-point-type'

const SHIPPING_POINT_MAP = new Map()
  .set(/\Sall/, types.ALL)
  .set(/\Sfishing-ground/, types.FISHING_GROUND)
  .set(/\Shaven/, types.HAVEN)
  .set(/\Sairport/, types.AIRPORT)
  .set(/\Sfactory/, types.FACTORY)
  .set(/\Scustomer/, types.CUSTOMER)
  .set(/\Swholesale-market/, types.WHOLESALE_MARKET)

export default SHIPPING_POINT_MAP



// WEBPACK FOOTER //
// ./src/static/shipping-point-map.js